"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MultiSelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AutoComplete = _interopRequireDefault(require("../AutoComplete"));

var _Chip = _interopRequireDefault(require("../Chip"));

require("./MultiSelector.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MultiSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiSelector, _React$Component);

  var _super = _createSuper(MultiSelector);

  function MultiSelector() {
    var _this;

    _classCallCheck(this, MultiSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      term: ''
    });

    _defineProperty(_assertThisInitialized(_this), "selectionAdd", function (selection) {
      if (selection.value === -1) {
        _this.props.options.forEach(function (option) {
          return _this.props.onAdd(option);
        });

        _this.setState({
          term: ''
        }, function () {
          _this.props.onSelection(_this.props.options);
        });
      } else {
        _this.props.onAdd(selection);

        _this.setState({
          term: ''
        }, function () {
          _this.props.onSelection(_this.props.selectedOptions.concat(selection));
        });
      }
    });

    return _this;
  }

  _createClass(MultiSelector, [{
    key: "optionsListCompile",
    value: function optionsListCompile() {
      var selectedOptionValue = this.props.selectedOptions.map(function (option) {
        return option.value;
      });
      return [{
        value: -1,
        display: 'All'
      }].concat(_toConsumableArray(this.props.options.filter(function (option) {
        return selectedOptionValue.indexOf(option.value) === -1;
      })));
    }
  }, {
    key: "selectionRemove",
    value: function selectionRemove(selection) {
      var updatedSelectedOptions = _toConsumableArray(this.props.selectedOptions);

      var selectionIndex = updatedSelectedOptions.findIndex(function (option) {
        return option.value === selection.value;
      });

      if (selectionIndex > -1) {
        updatedSelectedOptions.splice(selectionIndex, 1);
      }

      this.props.onRemoval(selection);
      this.props.onSelection(updatedSelectedOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_AutoComplete["default"], {
        options: this.optionsListCompile(),
        onSelect: this.selectionAdd,
        TextFieldProps: {
          label: this.props.hintText || 'Select options(s)...',
          error: Boolean(this.props.errorText),
          helperText: this.props.errorText
        },
        DownshiftProps: {
          inputValue: this.state.term,
          onInputValueChange: function onInputValueChange(term) {
            return _this2.setState({
              term: term
            });
          }
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "MultiSelector_tags"
      }, this.props.selectedOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
          key: option.value,
          name: option.display,
          actions: [{
            icon: 'close',
            tooltip: 'Remove',
            action: function action() {
              return _this2.selectionRemove(option);
            }
          }]
        });
      })));
    }
  }]);

  return MultiSelector;
}(_react["default"].Component);

exports.MultiSelector = MultiSelector;

_defineProperty(MultiSelector, "propTypes", {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
    display: _propTypes["default"].string.isRequired
  })).isRequired,
  selectedOptions: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  onSelection: _propTypes["default"].func.isRequired,
  hintText: _propTypes["default"].string,
  errorText: _propTypes["default"].string,
  onAdd: _propTypes["default"].func,
  onRemoval: _propTypes["default"].func
});

_defineProperty(MultiSelector, "defaultProps", {
  onAdd: function onAdd() {
    return null;
  },
  onRemoval: function onRemoval() {
    return null;
  }
});

var _default = MultiSelector;
exports["default"] = _default;